import axios from "axios";

const baseUrl = process.env.REACT_APP_BACKEND_URL + "api/posts";

const api = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  // Get token from localStorage (blitzware stores it there)
  const token = localStorage.getItem("access_token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

// Add response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token is invalid or expired
      console.warn("Authentication token expired or invalid");

      // Clear stored tokens
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");

      // Redirect to login page
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

const useAdvalvas = () => {
  const getAllPosts = async () => {
    try {
      const response = await api.get("/");
      return response.data;
    } catch (error) {
      console.error("Error fetching posts:", error);
      throw error;
    }
  };

  const addPost = async (postData, userId) => {
    try {
      const response = await api.post("/", { ...postData, userId });
      return response.data;
    } catch (error) {
      console.error("Error creating post:", error);
      throw error;
    }
  };

  const toggleLike = async (postId, userId) => {
    try {
      const response = await api.post(`/${postId}/like`, { userId });
      return response.data;
    } catch (error) {
      console.error("Error toggling like:", error);
      throw error;
    }
  };

  const addComment = async (postId, content, userId) => {
    try {
      const response = await api.post(`/${postId}/comments`, {
        content,
        userId,
      });
      return response.data;
    } catch (error) {
      console.error("Error adding comment:", error);
      throw error;
    }
  };

  const updatePost = async (postData, userId) => {
    try {
      const { id, title, description, category } = postData;
      const response = await api.put(`/${id}`, {
        title,
        description,
        category,
        userId,
      });
      return response.data;
    } catch (error) {
      console.error("Error updating post:", error);
      throw error;
    }
  };

  const deletePost = async (postId, userId) => {
    try {
      await api.delete(`/${postId}?userId=${userId}`);
      return true;
    } catch (error) {
      console.error("Error deleting post:", error);
      throw error;
    }
  };

  const togglePinPost = async (postId, isPinned, userId) => {
    try {
      const response = await api.patch(`/${postId}/pin`, { isPinned, userId });
      return response.data;
    } catch (error) {
      console.error("Error toggling pin status:", error);
      throw error;
    }
  };

  return {
    getAllPosts,
    addPost,
    updatePost,
    deletePost,
    togglePinPost,
    addComment,
    toggleLike,
  };
};

export default useAdvalvas;
